/* CCF flash sale corner card (DUBIA10). Hard stop after 2026-10-22T16:00:00Z. Shows after 8s or 40% scroll, once per session.
   Close = hidden 7 days; click-through = hidden for this sale. No overlay, no scroll lock. */
(function () {
  'use strict';
  var el = document.getElementById('ccf-flash');
  if (!el || window.__ccfFlash) return;
  window.__ccfFlash = true;
  var ENDS = Date.parse(el.getAttribute('data-ends') || '') || Date.UTC(2026, 9, 22, 16, 0, 0);
  function expired() { return Date.now() >= ENDS; }
  if (expired()) { el.parentNode.removeChild(el); return; }
  var key = 'ccfFlash_' + (el.getAttribute('data-key') || 'sale');
  var WEEK = 7 * 24 * 60 * 60 * 1000;
  function get(s, k) { try { return window[s].getItem(k); } catch (e) { return null; } }
  function set(s, k, v) { try { window[s].setItem(k, v); } catch (e) {} }
  var st = get('localStorage', key);
  if (st === 'clicked') return;
  if (st && /^closed:\d+$/.test(st) && Date.now() - parseInt(st.split(':')[1], 10) < WEEK) return;
  if (get('sessionStorage', key + '_seen')) return;

  var shown = false, timer = null;
  var mobile = window.matchMedia('(max-width: 749px)');

  function fixedAncestor(n) {
    while (n && n !== document.body && n !== document.documentElement) {
      if (n === el) return null;
      if (getComputedStyle(n).position === 'fixed') return n;
      n = n.parentElement;
    }
    return null;
  }
  function bottomOffset() {
    // height of fixed bars docked to the bottom (e.g. sticky add-to-cart) so the card sits above them
    if (!document.elementsFromPoint) return 0;
    var vh = window.innerHeight, vw = window.innerWidth, max = 0, seen = [];
    [0.1, 0.25, 0.5, 0.75].forEach(function (fx) {
      var stack = document.elementsFromPoint(vw * fx, vh - 3);
      for (var i = 0; i < stack.length; i++) {
        var f = fixedAncestor(stack[i]);
        if (!f || seen.indexOf(f) > -1) continue;
        seen.push(f);
        var r = f.getBoundingClientRect();
        if (r.height >= 20 && r.height <= vh * 0.5 && r.width >= vw * 0.6) max = Math.max(max, vh - r.top);
      }
    });
    return Math.round(max);
  }
  function atcButtons() {
    return document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"]');
  }
  function overlapsAtc() {
    if (!mobile.matches) return false;
    // resting position (ignores the slide transform)
    var bottom = parseFloat(getComputedStyle(el).bottom) || 0;
    var meBottom = window.innerHeight - bottom, me = { top: meBottom - el.offsetHeight, bottom: meBottom };
    var b = atcButtons();
    for (var i = 0; i < b.length; i++) {
      var r = b[i].getBoundingClientRect();
      if (!r.width || !r.height) continue;
      if (getComputedStyle(b[i]).visibility === 'hidden') continue;
      if (r.bottom > me.top - 8 && r.top < me.bottom + 8) return true;
    }
    return false;
  }
  var raf = 0;
  function layout() {
    raf = 0;
    if (!shown) return;
    if (expired()) { hide(); return; }
    el.style.pointerEvents = 'none';
    var off = bottomOffset();
    el.style.pointerEvents = '';
    el.style.setProperty('--ccf-flash-offset', off + 'px');
    el.classList.toggle('is-tucked', overlapsAtc());
  }
  function queue() { if (!raf) raf = requestAnimationFrame(layout); }

  function show() {
    if (shown) return;
    if (expired()) return;
    shown = true;
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    set('sessionStorage', key + '_seen', '1');
    el.hidden = false;
    layout();
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); layout(); }); });
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    setInterval(queue, 1500); // sticky bars can appear late
  }
  function hide(reason) {
    if (reason === 'closed') set('localStorage', key, 'closed:' + Date.now());
    if (reason === 'clicked') set('localStorage', key, 'clicked');
    el.classList.remove('is-in');
    setTimeout(function () { el.hidden = true; }, 400);
    shown = false;
    window.removeEventListener('scroll', queue);
  }
  function onScroll() {
    var d = document.documentElement;
    var max = Math.max(1, d.scrollHeight - window.innerHeight);
    if ((window.scrollY || d.scrollTop) / max >= 0.4) show();
  }

  el.querySelector('.ccf-flash__x').addEventListener('click', function () { hide('closed'); });
  el.querySelector('.ccf-flash__btn').addEventListener('click', function () { hide('clicked'); });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && shown) {
      var a = document.activeElement;
      if (a && a !== document.body && !el.contains(a) && a.closest && a.closest('[role="dialog"],details[open],cart-drawer.active')) return;
      hide('closed');
    }
  });
  timer = setTimeout(show, 8000);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
